module.exports = __webpack_public_path__ + "img/bedroom.be5030ca.webp";